import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, MessagesSquare } from 'lucide-react';
import api from '../../lib/api';
import { timeAgo } from '../categoryMeta';

/** Patient chat inbox — same conversations patients use in the portal,
 * reusing the existing staff chat endpoints (`/staff/portal/chat/threads`). */
export default function StaffAppChatsPage() {
  const [threads, setThreads] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    let active = true;
    api.get('/staff/portal/chat/threads').then((res) => { if (active) setThreads(res.data.threads || []); });
    return () => { active = false; };
  }, []);

  if (!threads) {
    return <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-muted-foreground" /></div>;
  }
  if (threads.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-24 text-center px-6" data-testid="staff-app-chats-empty">
        <MessagesSquare className="w-10 h-10 text-muted-foreground/60" />
        <p className="text-sm font-semibold">No patient conversations yet</p>
      </div>
    );
  }

  return (
    <div className="divide-y divide-border" data-testid="staff-app-chats-list">
      {threads.map((t) => (
        <button key={t.thread_id} onClick={() => navigate(`/staff-app/chats/${t.thread_id}`, { state: { patientName: t.patient_name } })}
          data-testid={`staff-app-chat-thread-${t.thread_id}`}
          className="staff-app-feed-item w-full flex items-center gap-3 px-4 py-3.5 text-left hover:bg-muted/50">
          <span className="w-9 h-9 rounded-full bg-primary/10 text-primary font-bold flex items-center justify-center shrink-0 text-sm">
            {(t.patient_name || 'P')[0].toUpperCase()}
          </span>
          <span className="min-w-0 flex-1">
            <span className="flex items-center justify-between gap-2">
              <span className="text-sm font-semibold truncate">{t.patient_name || 'A patient'}</span>
              <span className="text-[11px] text-muted-foreground shrink-0">{timeAgo(t.last_message_at)}</span>
            </span>
          </span>
          {!!t.unread_by_staff && (
            <span className="shrink-0 min-w-[18px] h-[18px] px-1 rounded-full bg-primary text-primary-foreground text-[10px] font-bold flex items-center justify-center">
              {t.unread_by_staff}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
